function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7,8C6.8,8,6.5,7.9,6.3,7.7l-6-5.9c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0L7,5.6l5.3-5.2c0.4-0.4,1-0.4,1.4,0 c0.4,0.4,0.4,1,0,1.4l-6,5.9C7.5,7.9,7.3,8,7,8z"
})));

const SvgArrow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 14 8",
  style: {
    enableBackground: "new 0 0 14 8"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.5cc64768.svg";
export { ForwardRef as ReactComponent };